var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t(
        "default",
        function() {
          return [
            _c("div", { staticClass: "single container-max page-content" }, [
              _c("div", { staticClass: "row position-relative" }, [
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6 col-lg-7 mt-5 mb-3 mb-md-5" },
                  [_vm._t("image-carousel")],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 col-md-6 col-lg-4 mt-md-5 buybox mb-md-5"
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "stick-in-parent",
                            rawName: "v-stick-in-parent"
                          }
                        ]
                      },
                      [
                        _vm.currentVariation.texts.name3
                          ? _c("p", { staticClass: "addtext mb-0" }, [
                              _vm._v(_vm._s(_vm.currentVariation.texts.name3))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentVariation.filter.hasManufacturer
                          ? _c(
                              "div",
                              { staticClass: "producertag mb-0 mb-md-3" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.currentVariation.item.manufacturer
                                        .externalName
                                    ) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "h1",
                          {
                            staticClass: "h2 title",
                            attrs: { "data-testing": "item-name" }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm._f("itemName")(_vm.currentVariation)
                                  ) +
                                  "\n              "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-none" },
                          [_vm._t("tag-list")],
                          2
                        ),
                        _vm._v(" "),
                        _vm.hasProp327Ebike ? _c("hr") : _vm._e(),
                        _vm._v(" "),
                        _vm.hasProp327Ebike
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "testimonial d-flex align-items-center"
                              },
                              [
                                _c("img", {
                                  staticClass: "img-fluid mr-3",
                                  attrs: { src: _vm.selectedImage }
                                }),
                                _vm._v(" "),
                                _c("p", { staticClass: "mb-0" }, [
                                  _c("em", [
                                    _vm._v(
                                      '"' +
                                        _vm._s(
                                          _vm.currentVariation.texts
                                            .shortDescription
                                        ) +
                                        '"'
                                    )
                                  ])
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasProp327Ebike ? _c("hr") : _vm._e(),
                        _vm._v(" "),
                        _vm.hasProp327Ebike
                          ? _c("div", { staticClass: "sizechart mb-2 mt-5" }, [
                              _c("span", [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "KloeppingVueTheme::SingleItem.SizeChartHeadline"
                                      )
                                    ) + " "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "d-inline",
                                  attrs: {
                                    type: "button",
                                    "data-toggle": "modal",
                                    "data-target": "#fs-sizetable",
                                    rel: "noopener noreferrer"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$translate(
                                          "KloeppingVueTheme::SingleItem.SizeChartText"
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.attributes.length || Object.keys(_vm.units).length
                          ? _c(
                              "div",
                              { staticClass: "mb-3" },
                              [_c("variation-select")],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentVariation.variation.bundleType === "bundle"
                          ? _c("item-bundle", {
                              attrs: {
                                "bundle-type":
                                  _vm.currentVariation.variation.bundleType,
                                "bundle-components":
                                  _vm.currentVariation.bundleComponents
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._t("before-price"),
                        _vm._v(" "),
                        _vm.currentVariation.filter.isSalable &&
                        _vm.variationGroupedProperties.length
                          ? _c("div", [_c("order-property-list")], 1)
                          : _vm._e(),
                        _vm._v(" "),
                        _c("graduated-prices"),
                        _vm._v(" "),
                        _c("item-price", {
                          attrs: {
                            "show-cross-price": _vm.isRecommendedPriceActive
                          }
                        }),
                        _vm._v(" "),
                        _vm._t("after-price"),
                        _vm._v(" "),
                        _vm._t("additional-content-after-vat"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "fs-availability" },
                          [_c("item-availability")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "mt-3 mb-4 fs-addtobasket" }, [
                          _c(
                            "div",
                            { staticClass: "w-100" },
                            [_vm._t("before-add-to-basket")],
                            2
                          ),
                          _vm._v(" "),
                          _vm.currentVariation.item.itemType === "set"
                            ? _c(
                                "div",
                                { staticClass: "alert alert-info w-100" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemSetInfo"
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass:
                                    "col-12 col-sm-7 col-md-12 col-lg-8 my-3 px-0"
                                },
                                [
                                  _c("add-to-basket", {
                                    attrs: {
                                      "variation-id":
                                        _vm.currentVariation.variation.id,
                                      "is-salable":
                                        !!_vm.currentVariation.filter &&
                                        _vm.currentVariation.filter.isSalable,
                                      "has-children":
                                        !!_vm.currentVariation.filter &&
                                        _vm.currentVariation.filter
                                          .hasActiveChildren,
                                      "interval-quantity":
                                        _vm.currentVariation.variation
                                          .intervalOrderQuantity || 1,
                                      "minimum-quantity":
                                        _vm.currentVariation.variation
                                          .minimumOrderQuantity,
                                      "maximum-quantity":
                                        !!_vm.currentVariation.variation
                                          .maximumOrderQuantity &&
                                        _vm.currentVariation.variation
                                          .maximumOrderQuantity > 0
                                          ? _vm.currentVariation.variation
                                              .maximumOrderQuantity
                                          : null,
                                      "order-properties": _vm.currentVariation.properties.filter(
                                        function(prop) {
                                          return prop.property.isOderProperty
                                        }
                                      ),
                                      "has-order-properties":
                                        _vm.currentVariation.hasOrderProperties,
                                      "has-required-order-property":
                                        _vm.currentVariation
                                          .hasRequiredOrderProperty,
                                      "use-large-scale": false,
                                      "show-quantity": true,
                                      "item-url": _vm._f("itemURL")(
                                        _vm.currentVariation
                                      ),
                                      "is-variation-selected":
                                        _vm.isVariationSelected &&
                                        _vm.currentVariation.filter.isSalable,
                                      "has-price": _vm._f(
                                        "hasItemDefaultPrice"
                                      )(_vm.currentVariation)
                                    }
                                  })
                                ],
                                1
                              ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "w-100" },
                            [_vm._t("after-add-to-basket")],
                            2
                          )
                        ]),
                        _vm._v(" "),
                        _vm.hasProp327Ebike
                          ? _c(
                              "ul",
                              {
                                staticClass:
                                  "list-unstyled d-flex flex-wrap partner mb-5 mb-md-0"
                              },
                              [
                                _c("li", { staticClass: "mb-2 mr-2" }, [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.$translate(
                                          "KloeppingVueTheme::FooterPartner.Partner1Link"
                                        )
                                      }
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "img-fluid",
                                        attrs: {
                                          src: _vm.$translate(
                                            "KloeppingVueTheme::FooterPartner.Partner1Icon"
                                          ),
                                          alt: _vm.$translate(
                                            "KloeppingVueTheme::FooterPartner.Partner1AltText"
                                          )
                                        }
                                      })
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("li", { staticClass: "mb-2 mr-2" }, [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.$translate(
                                          "KloeppingVueTheme::FooterPartner.Partner2Link"
                                        )
                                      }
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "img-fluid",
                                        attrs: {
                                          src: _vm.$translate(
                                            "KloeppingVueTheme::FooterPartner.Partner2Icon"
                                          ),
                                          alt: _vm.$translate(
                                            "KloeppingVueTheme::FooterPartner.Partner2AltText"
                                          )
                                        }
                                      })
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("li", { staticClass: "mb-2 mr-2" }, [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.$translate(
                                          "KloeppingVueTheme::FooterPartner.Partner3Link"
                                        )
                                      }
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "img-fluid",
                                        attrs: {
                                          src: _vm.$translate(
                                            "KloeppingVueTheme::FooterPartner.Partner3Icon"
                                          ),
                                          alt: _vm.$translate(
                                            "KloeppingVueTheme::FooterPartner.Partner3AltText"
                                          )
                                        }
                                      })
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("li", { staticClass: "mb-2 mr-2" }, [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.$translate(
                                          "KloeppingVueTheme::FooterPartner.Partner4Link"
                                        )
                                      }
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "img-fluid",
                                        attrs: {
                                          src: _vm.$translate(
                                            "KloeppingVueTheme::FooterPartner.Partner4Icon"
                                          ),
                                          alt: _vm.$translate(
                                            "KloeppingVueTheme::FooterPartner.Partner4AltText"
                                          )
                                        }
                                      })
                                    ]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._t("additional-content-after-add-to-basket")
                      ],
                      2
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-6" }, [
                  _c("p", { staticClass: "h3" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$translate(
                          "KloeppingVueTheme::SingleItem.DescriptionHeadline"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "my-4",
                    domProps: {
                      innerHTML: _vm._s(_vm.currentVariation.texts.description)
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "eu-responsible small" }, [
                    _c("p", { staticClass: "h4" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$translate(
                            "Ceres::Template.singleItemEuResponsiblePerson"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer
                              .responsibleName
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer
                              .responsibleStreet
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer
                              .responsibleHouseNo
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer
                              .responsiblePostCode
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer
                              .responsibleTown
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _vm.currentVariation.item.manufacturer
                        .responsibleCountryObject
                        ? _c("span", [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.currentVariation.item.manufacturer
                                    .responsibleCountryObject.name
                                ) +
                                "\n              "
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer
                              .responsibleEmail
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer
                              .responsiblePhoneNo
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer
                              .responsibleContactUrl
                          )
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "eu-responsible small mt-4" }, [
                    _c("p", { staticClass: "h4" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$translate(
                            "Ceres::Template.singleItemManufacturer"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.currentVariation.item.manufacturer.name)
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer.legalName
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.currentVariation.item.manufacturer.street)
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.currentVariation.item.manufacturer.houseNo)
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer.postcode
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.currentVariation.item.manufacturer.town)
                        )
                      ]),
                      _vm._v(" "),
                      _vm.currentVariation.item.manufacturer.countryObject
                        ? _c("span", [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.currentVariation.item.manufacturer
                                    .countryObject.name
                                ) +
                                "\n              "
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.currentVariation.item.manufacturer.email)
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.currentVariation.item.manufacturer.url)
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer.phoneNumber
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer.faxNumber
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer.contactUrl
                          )
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-6" }, [
                  _c(
                    "div",
                    { staticClass: "item-data-container mb-5 mb-md-0" },
                    [
                      _c("p", { staticClass: "h3" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$translate(
                              "KloeppingVueTheme::SingleItem.TechnicalDataHeadline"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "item-data" }, [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.currentVariation.texts.technicalData
                            )
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-3 text-center" }, [
                        _c(
                          "a",
                          {
                            staticClass:
                              "d-inline-block text-muted text-center p-2 btn-more",
                            attrs: {
                              href: "#",
                              onclick:
                                "event.preventDefault(); document.getElementsByClassName('item-data-container')[0].classList.toggle('show');"
                            }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "font-weight-bold show-more" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "KloeppingVueTheme::SingleItem.ShowMore"
                                    )
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "font-weight-bold show-less" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "KloeppingVueTheme::SingleItem.ShowLess"
                                    )
                                  )
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.hasProp327vehicle
              ? _c(
                  "div",
                  {
                    staticClass: "container-fluid single bg-gray py-3 py-md-5"
                  },
                  [
                    _c("div", { staticClass: "container-max" }, [
                      _c("div", { staticClass: "row usps" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-12 col-sm-6 col-lg-3 d-flex flex-row mb-4 mb-md-3 mb-lg-0"
                          },
                          [
                            _c("lazy-img", {
                              attrs: {
                                "image-url": _vm.$translate(
                                  "KloeppingVueTheme::SingleItemUSPs.USP1ImgUrl"
                                ),
                                "picture-alt": _vm.$translate(
                                  "KloeppingVueTheme::SingleItemUSPs.USP1Headline"
                                ),
                                "picture-class": "img-fluid"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "usp-text ml-3" }, [
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "KloeppingVueTheme::SingleItemUSPs.USP1Headline"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", {
                                staticClass: "mb-0",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$translate(
                                      "KloeppingVueTheme::SingleItemUSPs.USP1Text"
                                    )
                                  )
                                }
                              })
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-12 col-sm-6 col-lg-3 d-flex flex-row mb-4 mb-md-3 mb-lg-0"
                          },
                          [
                            _c("lazy-img", {
                              attrs: {
                                "image-url": _vm.$translate(
                                  "KloeppingVueTheme::SingleItemUSPs.USP2ImgUrl"
                                ),
                                "picture-alt": _vm.$translate(
                                  "KloeppingVueTheme::SingleItemUSPs.USP2Headline"
                                ),
                                "picture-class": "img-fluid"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "usp-text ml-3" }, [
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "KloeppingVueTheme::SingleItemUSPs.USP2Headline"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", {
                                staticClass: "mb-0",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$translate(
                                      "KloeppingVueTheme::SingleItemUSPs.USP2Text"
                                    )
                                  )
                                }
                              })
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-12 col-sm-6 col-lg-3 d-flex flex-row mb-4 mb-md-3 mb-lg-0"
                          },
                          [
                            _c("lazy-img", {
                              attrs: {
                                "image-url": _vm.$translate(
                                  "KloeppingVueTheme::SingleItemUSPs.USP3ImgUrl"
                                ),
                                "picture-alt": _vm.$translate(
                                  "KloeppingVueTheme::SingleItemUSPs.USP3Headline"
                                ),
                                "picture-class": "img-fluid"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "usp-text ml-3" }, [
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "KloeppingVueTheme::SingleItemUSPs.USP3Headline"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", {
                                staticClass: "mb-0",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$translate(
                                      "KloeppingVueTheme::SingleItemUSPs.USP3Text"
                                    )
                                  )
                                }
                              })
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-12 col-sm-6 col-lg-3 d-flex flex-row mb-4 mb-md-3 mb-lg-0"
                          },
                          [
                            _c("lazy-img", {
                              attrs: {
                                "image-url": _vm.$translate(
                                  "KloeppingVueTheme::SingleItemUSPs.USP4ImgUrl"
                                ),
                                "picture-alt": _vm.$translate(
                                  "KloeppingVueTheme::SingleItemUSPs.USP4Headline"
                                ),
                                "picture-class": "img-fluid"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "usp-text ml-3" }, [
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "KloeppingVueTheme::SingleItemUSPs.USP4Headline"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", {
                                staticClass: "mb-0",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$translate(
                                      "KloeppingVueTheme::SingleItemUSPs.USP4Text"
                                    )
                                  )
                                }
                              })
                            ])
                          ],
                          1
                        )
                      ])
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.hasProp327vehicle
              ? _c("div", { staticClass: "container-max mb-5 mb-md-0" }, [
                  _c("div", { staticClass: "row my-3 my-md-5" }, [
                    _c("div", { staticClass: "col-12 rts-wrapper" }, [
                      _c("div", { staticClass: "rts-img" }, [
                        _c("picture", [
                          _c("source", {
                            attrs: {
                              media: "(max-width:576px)",
                              srcset: _vm.$translate(
                                "KloeppingVueTheme::SingleItemUSPs.RTSMobileImg"
                              ),
                              alt: _vm.$translate(
                                "KloeppingVueTheme::SingleItemUSPs.RTSHeadline"
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "img-fluid mx-auto",
                            attrs: {
                              src: _vm.$translate(
                                "KloeppingVueTheme::SingleItemUSPs.RTSDesktopImg"
                              ),
                              alt: _vm.$translate(
                                "KloeppingVueTheme::SingleItemUSPs.RTSHeadline"
                              )
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-12 col-md-6 offset-md-6",
                          attrs: { id: "rtsSide" }
                        },
                        [
                          _c("p", { staticClass: "h3 text-white" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "KloeppingVueTheme::SingleItemUSPs.RTSHeadline"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "text-white" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "KloeppingVueTheme::SingleItemUSPs.RTSText"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "text-white font-weight-bold",
                              attrs: {
                                href: _vm.$translate(
                                  "KloeppingVueTheme::SingleItemUSPs.RTSLink"
                                )
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "KloeppingVueTheme::SingleItemUSPs.RTSLinkText"
                                  )
                                )
                              ),
                              _c("i", {
                                staticClass: "fa fa-arrow-right ml-3",
                                attrs: { "aria-hidden": "true" }
                              })
                            ]
                          )
                        ]
                      )
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "single container-max page-content" }, [
              _c(
                "div",
                { staticClass: "row cross-selling" },
                [
                  _vm._t("cross-selling-accessory"),
                  _vm._v(" "),
                  _vm._t("cross-selling-similar"),
                  _vm._v(" "),
                  _vm._t("feedback-container")
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { attrs: { id: "mobile-buybtn" } }, [
              _c(
                "div",
                { staticClass: "d-flex d-sm-none px-3 align-items-center" },
                [
                  _vm.attributes.length || Object.keys(_vm.units).length
                    ? _c(
                        "div",
                        { staticClass: "vselect mr-3" },
                        [_c("variation-select")],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "mobile-add" }, [
                    _vm.currentVariation.item.itemType === "set"
                      ? _c("div", { staticClass: "alert alert-info w-100" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.singleItemSetInfo"
                                )
                              ) +
                              "\n          "
                          )
                        ])
                      : _c(
                          "div",
                          {
                            staticClass:
                              "col-12 col-sm-7 col-md-12 col-lg-8 my-3 px-0"
                          },
                          [
                            _c("add-to-basket", {
                              attrs: {
                                "variation-id":
                                  _vm.currentVariation.variation.id,
                                "is-salable":
                                  !!_vm.currentVariation.filter &&
                                  _vm.currentVariation.filter.isSalable,
                                "has-children":
                                  !!_vm.currentVariation.filter &&
                                  _vm.currentVariation.filter.hasActiveChildren,
                                "interval-quantity":
                                  _vm.currentVariation.variation
                                    .intervalOrderQuantity || 1,
                                "minimum-quantity":
                                  _vm.currentVariation.variation
                                    .minimumOrderQuantity,
                                "maximum-quantity":
                                  !!_vm.currentVariation.variation
                                    .maximumOrderQuantity &&
                                  _vm.currentVariation.variation
                                    .maximumOrderQuantity > 0
                                    ? _vm.currentVariation.variation
                                        .maximumOrderQuantity
                                    : null,
                                "order-properties": _vm.currentVariation.properties.filter(
                                  function(prop) {
                                    return prop.property.isOderProperty
                                  }
                                ),
                                "has-order-properties":
                                  _vm.currentVariation.hasOrderProperties,
                                "has-required-order-property":
                                  _vm.currentVariation.hasRequiredOrderProperty,
                                "use-large-scale": false,
                                "show-quantity": true,
                                "item-url": _vm._f("itemURL")(
                                  _vm.currentVariation
                                ),
                                "is-variation-selected":
                                  _vm.isVariationSelected &&
                                  _vm.currentVariation.filter.isSalable,
                                "has-price": _vm._f("hasItemDefaultPrice")(
                                  _vm.currentVariation
                                )
                              }
                            })
                          ],
                          1
                        )
                  ])
                ]
              )
            ])
          ]
        },
        {
          getDataField: _vm.getDataField,
          getFilteredDataField: _vm.getFilteredDataField
        }
      ),
      _vm._v(" "),
      _vm.hasProp327Ebike
        ? _c(
            "div",
            {
              staticClass: "modal fade sizechart",
              attrs: {
                id: "fs-sizetable",
                "aria-hidden": "true",
                role: "dialog",
                tabindex: "-1"
              }
            },
            [
              _c(
                "div",
                { staticClass: "modal-dialog", attrs: { role: "document" } },
                [
                  _c("div", { staticClass: "modal-content" }, [
                    _c("div", { staticClass: "modal-header" }, [
                      _c(
                        "h5",
                        {
                          staticClass: "modal-title",
                          attrs: { id: "exampleModalLabel" }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "KloeppingVueTheme::SingleItem.SizeChartModalHeadline"
                              )
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._m(0)
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "modal-body" },
                      [_vm._t("size-table")],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { "data-dismiss": "modal", type: "button" }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "KloeppingVueTheme::SingleItem.SizeChartModalCloseBtn"
                              )
                            )
                          )
                        ]
                      )
                    ])
                  ])
                ]
              )
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          "aria-label": "Close",
          "data-dismiss": "modal",
          type: "button"
        }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }